import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility for combining and merging Tailwind CSS classes
 * This is a common pattern used in component libraries like shadcn/ui
 */
export function cn(...inputs: (string | undefined | null | boolean)[]) {
  return twMerge(clsx(inputs.filter(Boolean)));
}
